import React from 'react';

import Loadable from 'Jsx/Shared/Loadable';
import { LanguageFilterProps } from './types';

const LazyOrderBy: React.FC<LanguageFilterProps> = props => (
  <Loadable
    module={() =>
      import(
        /* webpackChunkname: "catalog-order-by" */
        './LanguageFilter'
      )
    }
    {...props}
  />
);

export default LazyOrderBy;
